/* Redesign 2026: tap the play button (product cards: under the heart; product gallery: under the heart) to play the
   product video over the image; tap again to stop. One video at a time; it also stops when scrolled out of view.
   Buttons come from snippets/kj-video-btn.liquid (data-mp4 = Shopify video, data-yt = YouTube id). */
(function () {
  'use strict';
  var current = null;   // { btn, layer, io }

  function host(btn) {
    var card = btn.closest('.product-item');
    if (card) return card.querySelector('.card-media') || card.querySelector('.card-product__wrapper');
    return btn.closest('.productView-image-wrapper');
  }

  function mp4Url(full, big) {
    // Liquid only exposes the 1080p file; Shopify also keeps lighter renditions with the same id
    return full.replace(/HD-1080p-[\d.]+Mbps/, big ? 'HD-720p-4.5Mbps' : 'SD-480p-1.5Mbps');
  }

  function start(btn) {
    stop();
    var box = host(btn); if (!box) return;
    var big = !btn.closest('.product-item');
    var layer = document.createElement('div');
    layer.className = 'kj-vlayer' + (big ? ' kj-vlayer--gal' : '');
    if (btn.dataset.mp4) {
      var full = btn.dataset.mp4, v = document.createElement('video');
      v.muted = true; v.loop = true; v.autoplay = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.onerror = function () { if (v.src.indexOf(full.split('?')[0]) === -1) { v.onerror = null; v.src = full; v.play().catch(function () {}); } };
      v.src = mp4Url(full, big);
      layer.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    } else if (btn.dataset.yt) {
      var id = btn.dataset.yt, f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&mute=1&playsinline=1&controls=0&loop=1&playlist=' + id + '&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1';
      f.allow = 'autoplay; encrypted-media'; f.setAttribute('frameborder', '0'); f.title = 'Product video';
      layer.classList.add('is-yt');
      layer.appendChild(f);
    }
    box.appendChild(layer);
    requestAnimationFrame(function () { layer.classList.add('is-on'); });
    btn.classList.add('is-playing'); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Stop video');
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (en) { if (!en[0].isIntersecting) stop(); }, { threshold: 0.25 });
      io.observe(box);
    }
    current = { btn: btn, layer: layer, io: io };
  }

  function stop() {
    if (!current) return;
    var c = current; current = null;
    if (c.io) c.io.disconnect();
    var v = c.layer.querySelector('video'); if (v) { try { v.pause(); } catch (e) {} }
    c.layer.classList.remove('is-on');
    setTimeout(function () { c.layer.remove(); }, 180);
    c.btn.classList.remove('is-playing'); c.btn.setAttribute('aria-pressed', 'false'); c.btn.setAttribute('aria-label', 'Play video');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kj-vbtn]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    if (current && current.btn === btn) stop(); else start(btn);
  }, true);
  // swiping the product gallery to another slide stops the gallery video
  document.addEventListener('scroll', function (e) {
    if (current && !current.btn.closest('.product-item') && e.target && e.target.closest && e.target.closest('.productView-nav')) stop();
  }, true);
  document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); });
})();
